import angular from 'angular'
import resolve from 'ioc/resolve'
import $appConfig from 'servicestack/config'
import templateUrl from 'emun.shopping.admin/admin-order.htm'
import CartController from 'emun.cart/cart.controller'
import AutoQuery from 'servicestack/auto-query/auto-query.es6'
import CartItem from 'emun.cart/cart-item.model'


class ShoppingAdminOrderController extends CartController {
    constructor ($cart) {
        super($cart)
        let $ctrl = this;
        let options = {
            url: `Cart/${this.orderId}.json?IncludeProducts=1`,
            autoLoad: true,
            onLoaded: this.orderLoaded,
            onEmpty() {
                this.query = new AutoQuery({
                    url: 'QueryCarts.json?IncludeProducts=1&OriginalOrderNumber=' + this.orderId,
                    autoLoad: true,
                    onLoaded: this.orderLoaded
                });
            }
        };
        this.query = new AutoQuery(options);
        let $rootScope = resolve('$rootScope');
        $rootScope.$on('cartRefunded', function() {
            $ctrl.query.load(true);
        });
        $rootScope.$on('orderCancelled', function() {
            $ctrl.query.load(true);
        });
        $rootScope.$on('orderPickedUp', function() {
            $ctrl.query.load(true);
        });
    }
    load(){return this.query.load.apply(this.query, arguments);}

    orderLoaded(args){
        this.order = args.first;
        this.order.items = this.order.items.map(i => new CartItem(i));
    }
}

const ShoppingAdminOrder = {
    bindings:{
        orderId: '@'
    },
    controller: ShoppingAdminOrderController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

angular.module('emun.shopping.admin').component('adminOrder', ShoppingAdminOrder);

export default ShoppingAdminOrder